import { useTranslation } from '../_providers/TranslationProvider.client'

export function usePrettySizeName<T>({
  id,
  displayValue,
}: {
  id: string | undefined | null
  displayValue: T
}): string | T {
  const translations = useTranslation()
  const translatedNames: Record<string, string> | undefined = translations.magnolia.general.sizes
  const untranslatedNames: Record<string, string> = {
    'XXS': '2X Small',
    'XS': 'X Small',
    'S': 'Small',
    'M': 'Medium',
    'L': 'Large',
    'XL': 'X Large',
    '2XL': '2X Large',
    '3XL': '3X Large',
    '4XL': '4X Large',
    '5XL': '5X Large',
    '6XL': '6X Large',
  }
  if (!id) {
    return displayValue
  }
  return translatedNames?.[id] ?? untranslatedNames[id] ?? displayValue
}
